import { KOREAN } from '@/app/app.config'
import { useCallback } from 'react'
import { Address, useKakaoPostcodePopup } from 'react-daum-postcode'

export type PostCodeResult = Address & { address: string }

const usePostcode = () => {
  const scriptURL = 'https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js'
  const useKorean = KOREAN

  const open = useKakaoPostcodePopup(scriptURL)

  const handleComplete = useCallback(
    (result: Address) => {
      let address = ''
      let extraAddress = ''

      //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (result.userSelectedType === 'R') {
        // 사용자가 도로명 주소를 선택했을 경우
        address = useKorean ? result.roadAddress : result.roadAddressEnglish
      } else {
        // 사용자가 지번 주소를 선택했을 경우(J)
        address = useKorean ? result.jibunAddress : result.jibunAddressEnglish
      }

      // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
      if (result.userSelectedType === 'R') {
        // 법정동명이 있을 경우 추가한다. (법정리는 제외)
        // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
        if (useKorean) {
          if (result.bname !== '' && /[동|로|가]$/g.test(result.bname)) {
            extraAddress += result.bname
          }
        } else {
          if (result.bnameEnglish !== '' && /[dong|ro|ga]$/g.test(result.bnameEnglish)) {
            extraAddress += result.bnameEnglish
          }
        }
        // 건물명이 있고, 공동주택일 경우 추가한다.
        if (result.buildingName !== '' && result.apartment === 'Y') {
          extraAddress += extraAddress !== '' ? ', ' + result.buildingName : result.buildingName
        }
        // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
        if (extraAddress !== '') {
          address += ' (' + extraAddress + ')'
        }
      }

      // console.log(result)
      // console.log(address) // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
      return {
        ...result,
        address: address,
      }
    },
    [useKorean]
  )

  const openSearchPostcodePopup = (callback: (address: PostCodeResult) => void) => {
    open({
      onComplete: handleCompleteCallback(callback),
      popupTitle: useKorean ? '주소 검색' : 'Search Address',
      popupKey: 'search_address',
    })
  }

  const handleCompleteCallback = useCallback(
    (callback: (address: PostCodeResult) => void) => {
      return (address: Address) => {
        callback(handleComplete(address))
      }
    },
    [handleComplete]
  )

  return {
    openSearchPostcodePopup,
    handleCompleteCallback,
    scriptURL,
  }
}

export default usePostcode
